import { Checkbox, Radio } from "antd";

import styled, { css } from "styled-components/macro";

export const Container = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.summary`
  cursor: pointer;

  h4 {
    font-size: 14px;
    margin-bottom: 12px;
    display: inline-block;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  ${({ bold }) =>
    bold
      ? css`
          font-weight: bold;
        `
      : ""};
  font-size: 12px !important;
  margin-bottom: 6px !important;
  margin-left: 0 !important;
  display: flex !important;
`;

export const StyledRadioGroup = styled(Radio.Group)`
  .ant-radio-wrapper {
    font-size: 12px !important;
    margin-bottom: 6px !important;
  }
`;

const candidatesSectionListMixin = css`
  height: 76px;
  padding: 17px 24px 19px 24px;
`;

const candidateBaseMixin = css`
  margin-top: 24px;
  height: 100px;
  padding: 32px 24px 19px 24px;
`;

export const Header = styled.header`
  background-color: white;
  display: flex;
  justify-content: flex-end;

  ${({ isBase }) => (isBase ? candidateBaseMixin : candidatesSectionListMixin)}
`;

export const SearchContainer = styled.div`
  min-width: 350px;
`;

export const Content = styled.section`
  display: flex;
  align-items: flex-start;
  margin-top: 24px;
`;

export const Sidebar = styled.div`
  width: 240px;
  margin: 0 30px 0 16px;
  flex-shrink: 0;
`;

export const Grid = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  grid-gap: 16px;
  margin-bottom: 40px;
`;
